module.exports = __webpack_public_path__ + "static/media/Battery-red.06cda6bb.svg";